import parsePhoneNumber from 'libphonenumber-js';

export interface CustomerPhoneNumberConfig {
  phoneNumber?: string;
  phoneCountryCode?: string;
}

export function renderPhoneNumber(c: CustomerPhoneNumberConfig): string {
  if (!c.phoneNumber || !c.phoneCountryCode) return '';

  try {
    const phone = parsePhoneNumber(c.phoneNumber, {
      defaultCallingCode: c.phoneCountryCode,
    });
    return phone ? phone.formatInternational() : '';
  } catch {
    return '';
  }
}

export function convertToE164(c: CustomerPhoneNumberConfig) {
  if (!c.phoneNumber || !c.phoneCountryCode) return undefined;

  try {
    const parsedNumber = parsePhoneNumber(c.phoneNumber, {
      defaultCallingCode: c.phoneCountryCode,
    });

    return parsedNumber ? parsedNumber.format('E.164') : undefined;
  } catch {
    return undefined;
  }
}
